<div class="card no-gutter widget-overview-box widget-overview-box-3 h-100">
	<div class="d-flex">
		<span class="overview-icon">
			<i class="pi pi-users"></i>
		</span>
		<span class="overview-title">
			<div class="d-flex flex-row">
				<div>Customers</div>
				<fa-icon class="mx-2" *ngIf="!guestRev" (click)="guestRev = true" [icon]="['far', 'badge-dollar']"></fa-icon>
				<fa-icon class="mx-2" *ngIf="guestRev" (click)="guestRev = false" [icon]="['far', 'tally']"></fa-icon>
			</div>
		</span>
	</div>

	<div class="p-grid overview-detail">
		<div class="col-6">
			<div class="overview-number">
				<span *ngIf="guestWeeklyMetric">
					<span *ngIf="guestRev">
						{{ guestWeeklyMetric.totalGuestRevenue | currency: "USD" }}
					</span>
					<span *ngIf="!guestRev">
						{{ guestWeeklyMetric.totalGuests }}
					</span>
				</span>
				<span *ngIf="!guestWeeklyMetric">
					<p-skeleton></p-skeleton>
				</span>
			</div>
			<div class="overview-subtext">Total</div>
		</div>
		<div class="col-6">
			<div class="overview-number">
				<span *ngIf="guestWeeklyMetric">
					<span *ngIf="guestRev">
						{{ guestWeeklyMetric.totalNewGuestRevenue | currency: "USD" }}
					</span>
					<span *ngIf="!guestRev">
						{{ guestWeeklyMetric.totalNewGuests }}
					</span>
				</span>
				<span *ngIf="!guestWeeklyMetric">
					<p-skeleton></p-skeleton>
				</span>
			</div>
			<div class="overview-subtext">New This Week</div>
		</div>
	</div>
	<p-divider></p-divider>
	<app-customer-statistic-dashboard></app-customer-statistic-dashboard>
</div>
